<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="商品名称">
                  <el-input style="width: 177px;" v-model="queryForm.productName"></el-input>
              </el-form-item>
              <el-form-item label="平台类型">
<!--                  <el-input style="width: 177px;" v-model="queryForm.platformType"></el-input>-->
                  <el-select
                      style="width:177px"
                      v-model="queryForm.platformType"
                      size="small"
                      clearable
                      placeholder="请选择"
                  >
                      <el-option
                          v-for="(item,index) in paltformList"
                          :label="item.value"
                          :value="item.key"
                      > </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="商品属性">
<!--                  <el-input style="width: 177px;" v-model="queryForm.attributeType"></el-input>-->
                  <el-select
                      style="width:177px"
                      v-model="queryForm.attributeType"
                      size="small"
                      clearable
                      placeholder="请选择"
                  >
                      <el-option
                          v-for="(item,index) in attributeList"
                          :label="item.value"
                          :value="item.key"
                      > </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getWashcloudPlatformProductList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addWashcloudPlatformProduct"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editWashcloudPlatformProduct(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteWashcloudPlatformProduct(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshWashcloudPlatformProductList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="washcloudPlatformProductList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="productId"
        label="平台商品ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="productPic"
        label="商品图片"
        width="180"
      >
          <template slot-scope="scope">
              <el-image @click='updateSrcList(scope.row.productPic)' style="width: 60px; height: 60px"
                        :src="scope.row.productPic" :preview-src-list="srcList"></el-image>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="productName"
        label="商品名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="platformType"
        label="平台类型"
        width="180"
      >
          <template slot-scope="scope">
              {{returnPaltform(scope.row.platformType)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="attributeType"
        label="商品属性"
        width="180"
      >
          <template slot-scope="scope">
              {{returnAttribute(scope.row.attributeType)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkWashcloudPlatformProduct(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editWashcloudPlatformProduct(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteWashcloudPlatformProduct(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="washcloudPlatformProductStates[washcloudPlatformProductState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="washcloudPlatformProduct"
          ref="washcloudPlatformProductForm"
          :rules="rules"
          label-width="100px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="平台商品ID"
            prop="productId"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="washcloudPlatformProduct.productId"
              :disabled="washcloudPlatformProductState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="商品图片"
            prop="productPic"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformProduct.productPic"-->
<!--              :disabled="washcloudPlatformProductState == 'check'"-->
<!--            ></el-input>-->
              <div style="width: 177px;display: flex;align-items: center;">
                  <el-input v-model="washcloudPlatformProduct.productPic" size="small" :disabled="washcloudPlatformProductState == 'check'"></el-input>
                  <el-button type="primary" :disabled="washcloudPlatformProductState == 'check'" size="small" style="margin-left: 2px;" @click="uploadImages()">上传图片
                      <el-upload action="" v-show="false" ref="uploads" class="avatar-uploader" :show-file-list="false"
                                 :http-request="uploadAvatar">
                          <el-button type="primary" size="small" class="as">上传</el-button>
                      </el-upload>
                  </el-button>
              </div>
          </el-form-item>
          <el-form-item
            label="商品名称"
            prop="productName"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="washcloudPlatformProduct.productName"
              :disabled="washcloudPlatformProductState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="平台类型"
            prop="platformType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformProduct.platformType"-->
<!--              :disabled="washcloudPlatformProductState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  style="width:177px"
                  v-model="washcloudPlatformProduct.platformType"
                  :disabled="washcloudPlatformProductState == 'check'"
                  size="small"
                  clearable
                  placeholder="请选择"
              >
                  <el-option
                      v-for="(item,index) in paltformList"
                      :label="item.value"
                      :value="item.key"
                  > </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="商品属性"
            prop="attributeType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformProduct.attributeType"-->
<!--              :disabled="washcloudPlatformProductState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  style="width:177px"
                  v-model="washcloudPlatformProduct.attributeType"
                  :disabled="washcloudPlatformProductState == 'check'"
                  size="small"
                  clearable
                  placeholder="请选择"
              >
                  <el-option
                      v-for="(item,index) in attributeList"
                      :label="item.value"
                      :value="item.key"
                  > </el-option>
              </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="washcloudPlatformProductState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetWashcloudPlatformProductList();
                    this.getWashcloudPlatformProductList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetWashcloudPlatformProductList();
                    this.getWashcloudPlatformProductList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     productId: '', //平台商品ID
                     productPic: '', //商品图片
                     productName: '', //商品名称
                     platformType: '', //平台类型
                     attributeType: '', //商品属性
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                washcloudPlatformProductState: 'add',
                washcloudPlatformProductStates: {
                    add: '新建平台套餐',
                    check: '查看平台套餐',
                    edit: '修改平台套餐'
                },

                multipleSelection: [],
                washcloudPlatformProductList: [],
                washcloudPlatformProduct: {
                    id: '', //
                    productId: '', //平台商品ID
                    productPic: '', //商品图片
                    productName: '', //商品名称
                    platformType: '', //平台类型
                    attributeType: '', //商品属性
                },
                btnLoading: false,
                srcList: [''],
                rules: {
                    productId: [{ required: true, message: '平台商品ID不能为空', trigger: 'blur' }],
                    productPic: [{ required: true, message: '商品图片不能为空', trigger: 'blur' }],
                    productName: [{ required: true, message: '商品名称不能为空', trigger: 'blur' }],
                    platformType: [{ required: true, message: '平台类型不能为空', trigger: 'blur' }],
                    attributeType: [{ required: true, message: '商品属性不能为空', trigger: 'blur' }],
                },
                paltformList: [],
                attributeList: [],
            };
        },
        created() {
            this.getWashcloudPlatformProductList();
            this.getEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getEnum(){
                get('/washcloud/utils/getEnum', { enumType: 'platform_type' }).then(res=>{
                    if(res.success){
                        this.paltformList = res.enumList;
                    }
                })
                get('/washcloud/utils/getEnum', { enumType: 'attribute_type' }).then(res=>{
                    if(res.success){
                        this.attributeList = res.enumList;
                    }
                })
            },
            uploadImages(){
                this.$refs.uploads.$el.querySelector(".as").click()
            },
            // 大图预览
            updateSrcList(src) {
                this.srcList[0] = src;
            },
            uploadAvatar(params) {
                console.log({ params });
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!types.includes(file.type)) {
                    this.$message({
                        message: '只能上传图片格式的文件，png.jpg或者jpeg',
                        type: 'error',
                        showClose: true,
                        duration: 2000
                    });
                    return;
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(`/mpp/image/upload`, formData).then((res) => {
                    console.log({ res });
                    if (res.success) {
                        this.washcloudPlatformProduct.productPic = res.url;
                    }
                });
            },
            returnPaltform(key){
                for (let item in this.paltformList) {
                    if(this.paltformList[item].key == key){
                        return this.paltformList[item].value;
                    }
                }
            },
            returnAttribute(key){
                for (let item in this.attributeList) {
                    if(this.attributeList[item].key == key){
                        return this.attributeList[item].value;
                    }
                }
            },
            resetWashcloudPlatformProductList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.washcloudPlatformProductList = [];
            },
            resetDialog() {
                this.washcloudPlatformProductState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      productId: '', //平台商品ID
                      productPic: '', //商品图片
                      productName: '', //商品名称
                      platformType: '', //平台类型
                      attributeType: '', //商品属性
                };
                this.getWashcloudPlatformProductList();
            },
            closeDialog() {
                this.showDialog = false
                this.washcloudPlatformProduct = {
                      id: '', //
                      productId: '', //平台商品ID
                      productPic: '', //商品图片
                      productName: '', //商品名称
                      platformType: '', //平台类型
                      attributeType: '', //商品属性
                };
            },
            submitForm() {
                if (this.washcloudPlatformProductState == 'add') {
                    this.$refs.washcloudPlatformProductForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/washcloud/platformproduct/add`,{ ...this.washcloudPlatformProduct }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetWashcloudPlatformProductList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.washcloudPlatformProductState == 'edit') {
                    this.$refs.washcloudPlatformProductForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/washcloud/platformproduct/edit`,{ ...this.washcloudPlatformProduct }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetWashcloudPlatformProductList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addWashcloudPlatformProduct() {
                this.showDialog = true;
                this.washcloudPlatformProductState = 'add';
            },
            checkWashcloudPlatformProduct(washcloudPlatformProductId) {
                console.log(washcloudPlatformProductId);
                this.currentWashcloudPlatformProductId = washcloudPlatformProductId;

                this.getWashcloudPlatformProductById();
                this.showDialog = true;
                this.washcloudPlatformProductState = 'check';
            },
            editWashcloudPlatformProduct(washcloudPlatformProductId) {
                console.log('washcloudPlatformProduct', washcloudPlatformProductId);
                if (washcloudPlatformProductId) {
                    this.currentWashcloudPlatformProductId = washcloudPlatformProductId;
                    this.getWashcloudPlatformProductById();
                } else {
                    this.washcloudPlatformProduct = { ...this.washcloudPlatformProduct, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.washcloudPlatformProductState = 'edit';
            },
            deleteWashcloudPlatformProduct(washcloudPlatformProductId) {
                let ids = '';
                if (washcloudPlatformProductId) {
                    ids = washcloudPlatformProductId;
                } else {
                    ids = this.multipleSelection.map((washcloudPlatformProduct) => washcloudPlatformProduct.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/washcloud/platformproduct/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetWashcloudPlatformProductList();
                                this.getWashcloudPlatformProductList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshWashcloudPlatformProductList() {
                this.resetWashcloudPlatformProductList();
                this.getWashcloudPlatformProductList();
            },
            getWashcloudPlatformProductList(query = {}) {
                this.loading = true;
                get(`/washcloud/platformproduct/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.washcloudPlatformProductList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getWashcloudPlatformProductById() {
                get(`/washcloud/platformproduct/get`,{ id: this.currentWashcloudPlatformProductId }).then((res) =>{
                    if(res.success){
                      this.washcloudPlatformProduct = { ...this.washcloudPlatformProduct, ...res.washcloudPlatformProduct };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportWashcloudPlatformProductList() {
                //this.btnLoading = true;
                exprotExcel(`/washcloud/platformproduct/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/washcloud/platformproduct/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/washcloud/platformproduct/importData`,formData);
              this.refreshWashcloudPlatformProductList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getWashcloudPlatformProductList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getWashcloudPlatformProductList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>